import { Box, styled, Table, TableCell, TableHead, TableRow } from '@mui/material';
// import { CultivatedAreaProjectPrintTableColumns } from 'components/common/DataGrid/Columns/CultivatedAreaCategoryColumns';
import React from 'react';

import TableBody from '@mui/material/TableBody';

interface IProps {
  rows: any;
  year: number;
}

interface IColumn {
  id: string;
  label: string;
  minWidth?: number;
  align?: 'right' | 'center';
  format?: (value: number) => string;
}

const CultivatedAreaProjectPrintTableColumns: IColumn[] = [
  { id: 'sgg_nm', label: '시', align: 'center' },
  { id: 'emd_nm', label: '읍면동', align: 'center' },
  { id: 'li_nm', label: '리', align: 'center' },
  { id: 'jibun', label: '지번', align: 'center' },
  { id: 'last_cltv_nm', label: '신고품목', align: 'center' },
  {
    id: 'last_cltv_area',
    label: '신고면적(㎡)',
    align: 'center',
  },
  { id: 'last_ai_area', label: '분석면적(㎡)', align: 'center' },
  { id: 'last_ai_cltv_list', label: '분석품목', align: 'center' },
  { id: 'this_cltv_area', label: '신고면적(㎡)', align: 'center' },
  { id: 'this_jagyeong', label: '자경/임차', align: 'center' },
  { id: 'this_cltv_nm', label: '재배품목', align: 'center' },
  { id: 'note', label: '비고', align: 'center' },
];

export const CultivatedDeclarationTable = ({ rows, year }: IProps) => {
  return (
    <Root>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell
              className="MuiCustomTableCell MuiCustomTableColumn MultiColumn"
              align="center"
              colSpan={4}
            >
              농지 소재지
            </TableCell>
            <TableCell
              className="MuiCustomTableCell MuiCustomTableColumn MultiColumn"
              align="center"
              rowSpan={2}
            >
              지적면적(㎡)
            </TableCell>
            <TableCell
              className="MuiCustomTableCell MuiCustomTableColumn MultiColumn"
              align="center"
              colSpan={4}
            >
              {Number(year) - 1}년 신고 내역
            </TableCell>
            <TableCell
              className="MuiCustomTableCell MuiCustomTableColumn MultiColumn"
              align="center"
              colSpan={5}
            >
              {Number(year)}년 신고 내역
            </TableCell>
          </TableRow>
          <TableRow>
            {CultivatedAreaProjectPrintTableColumns.map((column) => {
              return (
                <TableCell
                  className="MuiCustomTableCell  MuiCustomTableColumn"
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows
            ? rows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                    id="sgg_nm"
                  >
                    {row.sgg_nm}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.emd_nm}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.li_nm}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.jibun}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.land_area}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.last_cltv_nm}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.last_cltv_area}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.last_ai_area}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.this_cltv_area}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.last_ai_cltv_list}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.this_jagyeong}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.this_cltv_nm}
                  </TableCell>
                  <TableCell
                    className="MuiCustomTableCell"
                    align="center"
                  >
                    {row.note}
                  </TableCell>
                </TableRow>
              ))
            : null}
        </TableBody>
      </Table>
    </Root>
  );
};

const Root = styled(Box)<{}>(({ theme }) => ({
  height: '70vh !important',
  overflowY: 'scroll',
  marginBottom: '100px !important',

  '@media print': {
    width: 'auto !important',
    height: 'auto !important',
    overflow: 'visible !important',
  },

  '& .MuiCustomTableCell': {
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    ':first-of-type': {
      borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    },
  },
  '& .MuiCustomTableColumn': {
    backgroundColor: '#D2D2D2',
    fontWeight: 600,
  },
  '& .MultiColumn': {
    height: 80,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
}));
